export const q = (target) => {
  const nlToArr = (els) => Array.prototype.slice.call(els);
  const node = document.querySelector.bind(document);
  const nodeList = document.querySelectorAll.bind(document);
  const qs = (target) => node(target);
  const qsAll = (target) => nlToArr(nodeList(target));

  let els;
  els = qsAll(target);
  if (els.length <= 1) {
    els = qs(target);
  }
  return els;
}

export const clickAndEnterListener = (el, fn) => {
  if (el) {
    if (Array.isArray(el)) {
      el.forEach(x => {
        x.addEventListener('click', (e) => {
          e.preventDefault();
          fn(e);
        });
        x.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            fn(e);
          };
        });
      });
    } else {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        fn(e);
      });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          fn(e);
        };
      });
    }
  }
}

export function getElementDistanceFromTop(el) {
  return window.pageYOffset + el.getBoundingClientRect().top;
}

export function compareArrays() {
  // https://bit.ly/3IkZJ6Y ——— COMPARE ARRAYS
  // Warn if overriding existing method
  if (Array.prototype.equals)
    console.warn('Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there’s a framework conflict or you’ve got double inclusions in your code.');
    // attach the .equals method to Array's prototype to call it on any array
  Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
      return false;
    // if the argument is the same array, we can be sure the contents are same as well
    if (array === this)
      return true;
    // compare lengths - can save a lot of time
    if (this.length != array.length)
      return false;

    for (var i = 0, l = this.length; i < l; i++) {
      // Check if we have nested arrays
      if (this[i] instanceof Array && array[i] instanceof Array) {
        // recurse into the nested arrays
        if (!this[i].equals(array[i]))
          return false;
      }
      else if (this[i] != array[i]) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
      }
    }
    return true;
  }
  // Hide method from for-in loops
  Object.defineProperty(Array.prototype, 'equals', { enumerable: false });
  // -------------
}
